import { createFileRoute } from "@tanstack/react-router";
import AdminGrants from "@/pages/admin/AdminGrants";

export const Route = createFileRoute("/admin/subvenciones")({ component: AdminGrants });
